import * as fromDatatype from "../../../../models/datatype-library";
import { BaseCriteriaDtoModel } from "./base-dto.model";

export class BranchSettlementMethodCriteriaDTO extends BaseCriteriaDtoModel {
    namespace?: string;
    module_guid?: string;
    applet_guid?: string;
    branch_guid?: string;
    branch_guids?: any[];
    fi_item_hdr_guid?: string;
    obj_type?: string;
    guids?: any[];
    sort_code?: string;
    used_for_purchases?: boolean;
    used_for_sales?: boolean;
}